import React from "react";
import "./style.scss";
import errorIcon from "../../../assets/icons/errorModalIcon.svg";
import {useDispatch, useSelector} from "react-redux";
import {clearErrors} from "../../../store/reducers/error";
import {capitalizeFirstLetter} from "../../../utils/helpers/string";

function ErrorModal() {
  const [open, setOpen] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const dispatch = useDispatch();

  const handleClose = () => {
    setOpen(false);
    dispatch(clearErrors());
  };

  const handleCustomButtonClick = () => {
    if (customBtn === "verification-kyc/*") {
      window.location.href = "/verification-kyc";
    }
    handleClose();
  };

  const {title, msg, status, customBtn} = useSelector((state) => state.error);

  React.useEffect(() => {
    setOpen(true);
    setMessage(msg);
    if (status === 500 && !msg) {
      setMessage("Internal server error. Please try again later.");
    }
  }, [title, msg, status]);

  return msg && status ? (
    <div
      className="error_modal_overlay"
      onClick={() => handleClose(false)}
    >
      <div className="error_modal_container errorPopupContainer">
        <div
          className="error_modal_container_top popupMessageTopSection"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <div className="tick_icon popupIcon">
            <img
              src={errorIcon}
              alt="error"
            />
          </div>
        </div>

        <div
          className="error_modal_container_bottom popupMessageBottomSection"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <h1>Error</h1>
          <p style={{whiteSpace: "pre-line"}}>{capitalizeFirstLetter(msg)}</p>
          <button
            className="error_modal_close_btn"
            onClick={customBtn ? handleCustomButtonClick : () => handleClose(false)}
          >
            {customBtn ? "Submit KYC" : "Close"}
          </button>
        </div>
      </div>
    </div>
  ) : (
    false
  );
}

export default ErrorModal;
